import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl leading-8 block font-normal text-gray-500 mt-[1.3333333em]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full rounded-lg",
    src: "/img/learning/dns-record-types/dns-record-types.jpg",
    alt: "An illustration of stars in a galaxy, representing the different DNS record types.",
    title: "An illustration of stars in a galaxy, representing the different DNS record types.",
    width: "1200",
    height: "600"
  }),
  /*#__PURE__*/_createElementVNode("figcaption", null, [
    /*#__PURE__*/_createTextVNode("A galaxy full off DNS records. By NsLookup.io. Licensed under "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://creativecommons.org/licenses/by/4.0/",
      title: "Creative Commons By 4.0 licence",
      rel: "nofollow"
    }, "CC By 4.0"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "All the record types are strictly defined in so-called RFCs (request for comments). Since the beginning of the domain name system, a lot of new record types have been added. Some record types have also been declared obsolete, because they have been replaced by a newer record type.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "There are many different types of DNS record in existence. Most of them are used only occasionally. Only a couple record types are used very frequently.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("figure", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/img/learning/dns-record-types/all-dns-record-types.png",
    target: "_blank",
    rel: "noopener noreferrer"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-full",
      src: "/img/learning/dns-record-types/all-dns-record-types.png",
      alt: "An overview of the DNS record types",
      title: "An overview of the DNS record types",
      width: "1448",
      height: "1176"
    })
  ]),
  /*#__PURE__*/_createElementVNode("figcaption", null, [
    /*#__PURE__*/_createTextVNode("All DNS record types. By NsLookup.io. Licensed under "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://creativecommons.org/licenses/by/4.0/",
      title: "Creative Commons By 4.0 licence",
      rel: "nofollow"
    }, "CC By 4.0"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Some of the most commonly used DNS record types are:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "These are all the DNS record types that are currently in use:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "AFSDB"),
  /*#__PURE__*/_createTextVNode(" — AFS database location")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "APL"),
  /*#__PURE__*/_createTextVNode(" — Address prefix list")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "AXFR"),
  /*#__PURE__*/_createTextVNode(" — Authoritative zone transfer")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CAA"),
  /*#__PURE__*/_createTextVNode(" — Certification authority authorization")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CDNSKEY"),
  /*#__PURE__*/_createTextVNode(" — Child copy of a DNSKEY")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CDS"),
  /*#__PURE__*/_createTextVNode(" — Child copy of DS")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CERT"),
  /*#__PURE__*/_createTextVNode(" — Cryptographic certificate")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "CSYNC"),
  /*#__PURE__*/_createTextVNode(" — Child-to-parent synchronization")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "DHCID"),
  /*#__PURE__*/_createTextVNode(" — DHCP identifier")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "DLV"),
  /*#__PURE__*/_createTextVNode(" — DNSSEC lookaside validation")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "DNAME"),
  /*#__PURE__*/_createTextVNode(" — Delegation name")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "DNSKEY"),
  /*#__PURE__*/_createTextVNode(" — Cryptographic key for DNSSEC")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "DS"),
  /*#__PURE__*/_createTextVNode(" — Delegation signer")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "EUI48"),
  /*#__PURE__*/_createTextVNode(" — MAC address (EUI-48)")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "EUI64"),
  /*#__PURE__*/_createTextVNode(" — Mac address (EUI-64)")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "HINFO"),
  /*#__PURE__*/_createTextVNode(" — Host information")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "HIP"),
  /*#__PURE__*/_createTextVNode(" — Host identification protocol")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "HTTPS"),
  /*#__PURE__*/_createTextVNode(" — HTTPS binding")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "IPSECKEY"),
  /*#__PURE__*/_createTextVNode(" — Cryptographic key for IPsec")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "IXFR"),
  /*#__PURE__*/_createTextVNode(" — Incremental zone transfer")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "KEY"),
  /*#__PURE__*/_createTextVNode(" — Cryptographic key for DNSSEC (obsoleted by DNSKEY)")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "KX"),
  /*#__PURE__*/_createTextVNode(" — Key exchange")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "LOC"),
  /*#__PURE__*/_createTextVNode(" — Geographical location")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "NAPTR"),
  /*#__PURE__*/_createTextVNode(" — Naming authority pointer")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "NSEC3"),
  /*#__PURE__*/_createTextVNode(" — Next secure (version 3)")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "NSEC3PARAM"),
  /*#__PURE__*/_createTextVNode(" — Parameter for NSEC3")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "NSEC"),
  /*#__PURE__*/_createTextVNode(" — Next secure (obsoleted by NSEC3)")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "NXT"),
  /*#__PURE__*/_createTextVNode(" — DNSSEC key (obsoleted by NSEC)")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "OPENPGPKEY"),
  /*#__PURE__*/_createTextVNode(" — Public key for OpenPGP")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "OPT"),
  /*#__PURE__*/_createTextVNode(" — EDNS option")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "RP"),
  /*#__PURE__*/_createTextVNode(" — Responsible person")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "RRSIG"),
  /*#__PURE__*/_createTextVNode(" — Resource record signature for DNSSEC")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "SIG"),
  /*#__PURE__*/_createTextVNode(" — Resource record signature for DNSSEC (obsoleted by RRSIG)")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "SMIMEA"),
  /*#__PURE__*/_createTextVNode(" — S/MIME association")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "SSHFP"),
  /*#__PURE__*/_createTextVNode(" — Public key fingerprint for SSH")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "SVCB"),
  /*#__PURE__*/_createTextVNode(" — Service binding")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TA"),
  /*#__PURE__*/_createTextVNode(" — Trust authority for DNSSEC")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TKEY"),
  /*#__PURE__*/_createTextVNode(" — Transaction key")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TLSA"),
  /*#__PURE__*/_createTextVNode(" — Certificate association for TLS")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "TSIG"),
  /*#__PURE__*/_createTextVNode(" — Transaction signature")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "URI"),
  /*#__PURE__*/_createTextVNode(" — Uniform resource identifier")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "ZONEMD"),
  /*#__PURE__*/_createTextVNode(" — Message digest for DNS zones")
], -1)

import BlogPost from '@/components/layout/BlogPost.vue';

import { ruurtjan } from '@/common/authors';
import { BlogMeta } from '@/common/blogMeta';
import { Breadcrumb, learningBreadcrumb } from '@/model/Breadcrumb';

const url = '/learning/dns-record-types/';
const breadcrumb: Breadcrumb = { url, title: 'DNS record types' };

const meta: BlogMeta = {
  tag: 'DNS concepts',
  url,
  breadcrumbs: [learningBreadcrumb],
  title: 'All DNS record types',
  description: 'An overview of all the DNS record types. Each DNS record type is briefly explained, and extensive explanations are available in linked articles.',
  overviewImage: '/img/learning/dns-record-types/dns-record-types-small.png',
  overviewImageAlt: 'An overview of the DNS record types',
  overviewDescription: 'An overview of all the DNS record types. Each DNS record type is briefly explained, and extensive explanations are available in linked articles.',
  author: ruurtjan,
  img1024x512: 'https://www.nslookup.io/img/learning/dns-record-types/dns-record-types-social.jpg',
  img1200x630: 'https://www.nslookup.io/img/learning/dns-record-types/dns-record-types-social.jpg',
  written: new Date('2021-09-09T07:08:34.241Z'),
  updated: new Date('2023-03-28T11:59:59.243Z'),
};

const __default__ = {
  meta,
  breadcrumb,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DnsRecordTypes',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"ImageObject\", \"author\": { \"@type\": \"Person\", \"email\": \"mailto:ruurtjan@nslookup.io\", \"image\": \"https://www.nslookup.io/img/ruurtjan-lg.jpg\", \"jobTitle\": \"CEO\", \"name\": \"Ruurtjan Pul\", \"url\": \"https://www.nslookup.io/about/ruurtjan-pul/\" }, \"copyrightHolder\": { \"@type\": \"Organization\", \"url\": \"https://www.nslookup.io/\", \"email\": \"hello@nslookup.io\" }, \"copyrightYear\": 2023, \"contentUrl\": \"https://www.nslookup.io/img/learning/dns-record-types/dns-record-types.jpg\", \"license\": \"https://creativecommons.org/licenses/by/4.0/\", \"acquireLicensePage\": \"https://creativecommons.org/licenses/by/4.0/\" } ")
        ]),
        _: 1
      })),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"ImageObject\", \"author\": { \"@type\": \"Person\", \"email\": \"mailto:ruurtjan@nslookup.io\", \"image\": \"https://www.nslookup.io/img/ruurtjan-lg.jpg\", \"jobTitle\": \"CEO\", \"name\": \"Ruurtjan Pul\", \"url\": \"https://www.nslookup.io/about/ruurtjan-pul/\" }, \"copyrightHolder\": { \"@type\": \"Organization\", \"url\": \"https://www.nslookup.io/\", \"email\": \"hello@nslookup.io\" }, \"copyrightYear\": 2021, \"contentUrl\": \"https://www.nslookup.io/img/learning/dns-record-types/all-dns-record-types.png\", \"license\": \"https://creativecommons.org/licenses/by/4.0/\", \"acquireLicensePage\": \"https://creativecommons.org/licenses/by/4.0/\" } ")
        ]),
        _: 1
      }))
    ])),
    _createVNode(BlogPost, {
      title: meta.title,
      description: meta.description,
      url: `https://www.nslookup.io${meta.url}`,
      breadcrumbs: meta.breadcrumbs,
      img1024x512: meta.img1024x512,
      img1200x630: meta.img1200x630,
      written: meta.written,
      updated: meta.updated,
      author: meta.author,
      editor: meta.editor
    }, {
      default: _withCtx(() => [
        _createElementVNode("strong", _hoisted_1, [
          _createTextVNode("Every DNS record has a type. This type defines what the content of the record means. For example, a DNS record of type MX contains the location of a mail exchange server. So when you want to know the mail server of some email address, you can perform a "),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode("DNS lookup")
            ]),
            _: 1
          }),
          _createTextVNode(" that queries the MX records.")
        ]),
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/a/" }, {
                default: _withCtx(() => [
                  _createTextVNode("A")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — IPv4 address")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/aaaa/" }, {
                default: _withCtx(() => [
                  _createTextVNode("AAAA")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — IPv6 address")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/cname/" }, {
                default: _withCtx(() => [
                  _createTextVNode("CNAME")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Canonical name")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/mx/" }, {
                default: _withCtx(() => [
                  _createTextVNode("MX")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Mail exchange")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/ns/" }, {
                default: _withCtx(() => [
                  _createTextVNode("NS")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Name server")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/txt/" }, {
                default: _withCtx(() => [
                  _createTextVNode("TXT")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Human-readable text")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/soa/" }, {
                default: _withCtx(() => [
                  _createTextVNode("SOA")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Start of authority")
          ])
        ]),
        _hoisted_7,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/a/" }, {
                default: _withCtx(() => [
                  _createTextVNode("A")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — IPv4 address")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/aaaa/" }, {
                default: _withCtx(() => [
                  _createTextVNode("AAAA")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — IPv6 address")
          ]),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/cname/" }, {
                default: _withCtx(() => [
                  _createTextVNode("CNAME")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Canonical name")
          ]),
          _hoisted_15,
          _hoisted_16,
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _hoisted_25,
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/mx/" }, {
                default: _withCtx(() => [
                  _createTextVNode("MX")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Mail exchange")
          ]),
          _hoisted_31,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/ns/" }, {
                default: _withCtx(() => [
                  _createTextVNode("NS")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Name server")
          ]),
          _hoisted_32,
          _hoisted_33,
          _hoisted_34,
          _hoisted_35,
          _hoisted_36,
          _hoisted_37,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/ptr/" }, {
                default: _withCtx(() => [
                  _createTextVNode("PTR")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Canonical name pointer")
          ]),
          _hoisted_38,
          _hoisted_39,
          _hoisted_40,
          _hoisted_41,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/soa/" }, {
                default: _withCtx(() => [
                  _createTextVNode("SOA")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Start of authority")
          ]),
          _hoisted_42,
          _hoisted_43,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/srv/" }, {
                default: _withCtx(() => [
                  _createTextVNode("SRV")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Service locator")
          ]),
          _hoisted_44,
          _hoisted_45,
          _hoisted_46,
          _hoisted_47,
          _createElementVNode("li", null, [
            _createElementVNode("strong", null, [
              _createVNode(_component_router_link, { to: "/learning/dns-record-types/txt/" }, {
                default: _withCtx(() => [
                  _createTextVNode("TXT")
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" — Human-readable text")
          ]),
          _hoisted_48,
          _hoisted_49
        ])
      ]),
      _: 1
    }, 8, ["title", "description", "url", "breadcrumbs", "img1024x512", "img1200x630", "written", "updated", "author", "editor"])
  ], 64))
}
}

})